import createQueryContext from 'react-fetching-library-context';
import {
  adminVerifyAction,
  getCurrentUserAction,
  resetPassword,
  signInAction,
  SignInParams,
  signOutAction,
} from './current_user';
import { ICurrentUser } from './current_user.types';
import { useMutation } from 'react-fetching-library';
import { setIsAuthorized } from 'helpers/state';

const { useQueryContext: useCurrentUser, Provider: CurrentUserProvider } =
  createQueryContext<ICurrentUser>(getCurrentUserAction);

export { useCurrentUser, CurrentUserProvider };

export function useSignIn() {
  const signIn = useMutation(signInAction);

  return async function (params: SignInParams) {
    const result = await signIn.mutate(params);
    if (!result.error) {
      setIsAuthorized(true);
    }
    return result;
  };
}

export function useAdminVerify() {
  const verify = useMutation(adminVerifyAction);

  return async function (token: string) {
    return await verify.mutate(token);
  };
}

export function useSignOut() {
  const signOut = useMutation(signOutAction);
  const currentUser = useCurrentUser();

  return async function () {
    setIsAuthorized(false);

    const result = await signOut.mutate({});

    if (result.error) {
      setIsAuthorized(true);
    }
    return await currentUser.query(null);
  };
}

export function useResetPassword() {
  const reset = useMutation(resetPassword);

  return async function (email: string) {
    return await reset.mutate(email);
  };
}
